import React from "react";
import {
	TopToolbar,
	useListContext,
	sanitizeListRestProps,
} from "react-admin";
import { MovementsButton } from "../../../components/StorageOperations/MovementsButton";

export const StorageTransactionsActions = (props) => {
	const { className, filters, ...rest } = props;
	const { filterValues, resource, showFilter, displayedFilters } = useListContext(props);

	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
			{filters &&
				React.cloneElement(filters, {
					resource,
					showFilter,
					displayedFilters,
					filterValues,
					context: "button",
				})}
			<MovementsButton />
		</TopToolbar>
	);
};
